import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import { StyledMobileTabNavButton } from "./mobile-tab-nav-button.scss";
const MobileTabNavButton = (props)=>{
    const { label, selected, theme } = props;
    return /*#__PURE__*/ _jsx(StyledMobileTabNavButton, {
        className: classnames("tab-nav-button", {
            selected
        }, theme),
        children: label
    });
};
export default MobileTabNavButton;
